import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./app.css";
import BackToTop from "./components/helper/back-to-top/back-to-top";
import ChangeTheme from "./components/helper/change-theme/change-theme";
import ScrollToTop from "./components/helper/scroll-to-top";
import { ThemeContext } from "./contexts/theme-context";
import { HomePage, ProjectPage } from "./pages";
import { createTheme, ThemeProvider } from "@mui/material";
import IntList from "./components/Interviews/IntList";
import IntAuth from "./components/Interviews/IntAuth";
function App() {
  const { theme, isDark } = useContext(ThemeContext);

  const MUItheme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: {
            // Color for filled chip
            backgroundColor: isDark
              ? "rgb(29, 255, 26,0.6)"
              : "rgb(0, 0, 0,0.9)",
            color: !isDark ? "white" : "black",
            "&:hover": {
              // Hover background color for filled chip
              backgroundColor: isDark
                ? "rgb(29, 255, 26,0.9)"
                : "rgb(0, 0, 0,0.7)",
            },
          },
          outlined: {
            // Border color for outlined chip
            borderColor: isDark ? "rgb(29, 255, 26,0.8)" : "rgb(0, 0, 0,0.8)",
            // Color for outlined chip
            backgroundColor: "rgb(29, 255, 26,0)",
            color: isDark ? "rgb(29, 255, 26,0.8)" : "rgb(0, 0, 0,0.8)",
            "&:hover": {
              // Hover background color for filled chip
              backgroundColor: "rgb(29, 255, 26,0.7)",
            },
          },
          outlinedPrimary: {
            // Border color for primary outlined chip
            borderColor: "primary.main",
            // Color for primary outlined chip
            color: "primary.main",
          },
          outlinedSecondary: {
            // Border color for secondary outlined chip
            borderColor: "secondary.main",
            // Color for secondary outlined chip
            color: "secondary.main",
          },
        },
      },
    },
  });
  return (
    <ThemeProvider theme={MUItheme}>
      <div style={{ backgroundColor: theme.secondary }}>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} exact />
            <Route path="/projects" element={<ProjectPage />} exact />
            <Route path="/int" element={<IntAuth />} exact />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        <BackToTop />
        <ChangeTheme />
      </div>
    </ThemeProvider>
  );
}

// predev
export default App;
